import React, { Component, Fragment } from 'react';
import Breadcrumb from '../components/common/breadcrumb';
import data from '../assets/data/invoice';
import Datatable from '../components/common/datatableInvoice';

export class Invoice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totalOrders: [],
            oldstore: []
        };
    }
    componentDidMount() {
        if (!localStorage.getItem('userInfo')) {
            window.location.href = '/admin';
            return
        }
        this.fetchInvoice(); 
    }

    fetchInvoice = () => {
        let _this = this
        fetch(`${process.env['REACT_APP_HOST']}/api/orders/all/`)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                 _this.setState({ totalOrders: result, oldstore: result })
                // console.log(result);
                // let total = 0
                // this.state.totalOrders.map((order, i) => {
                //     total = total + order.totalPrice
                //     this.setState({ totalEarning: total })
                // })
            });
    }
    search = (e) => {
        let search_str = (e.target.value).toLowerCase();

        if (search_str == "") {
            this.setState({ totalOrders: this.state.oldstore })
            return
        }

        let data = this.state.oldstore.filter(x1 => {
            if(x1.invoiceId){
                if (((x1.invoiceId)).toString().indexOf(search_str) >= 0) {
                    return true
                }
            }
            if (x1.orderItems.filter(x2 => {
                if (((x2.productId.name).toLowerCase()).indexOf(search_str) >= 0) {
                    return true
                } else {
                    return false
                }
            }).length > 0) {
                return true
            }
            else {
                return false
            }
        })
        console.log("data");
        console.log(data);

        this.setState({ totalOrders: data })

    }
    render() {
        return (
            <Fragment>
                <Breadcrumb title="Invoice" parent="Invoice" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">

                                <div className="card-header">

                                    <nav class="navbar navbar-light bg-light justify-content-between">
                                        <h5>Invoice List</h5>
                                        <form class="form-inline">
                                            <input class="form-control mr-sm-2" onChange={this.search} type="search" placeholder="Search" aria-label="Search" />
                                            {/* <button class="btn btn-outline-success my-2 my-sm-0" >Search</button> */}
                                        </form>
                                    </nav>

                                </div>
                                <div className="card-body pt-0">
                                    <div id="basicScenario" className="product-list">

                                       
                                        {this.state.oldstore.length > 0 ?
                                            <Datatable
                                                multiSelectOption={false}
                                                myData={this.state.totalOrders}
                                                pageSize={10}
                                                pagination={true}
                                                class="-striped -highlight"
                                            />
                                            : null}




                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Invoice
